var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, forwardRef, useContext, useEffect, useRef, useState, memo } from "react";
const DesmosContext = createContext(null);
export function elt(calc) {
    return calc.domChangeDetector.elt;
}
export const GraphingCalculator = forwardRef(function GraphingCalculator(props, ref) {
    var _a;
    const [calculator, setCalculator] = useState();
    const div = useRef();
    useEffect(() => {
        const { attributes, children } = props, options = __rest(props, ["attributes", "children"]);
        const calculator = Desmos.GraphingCalculator(div.current, options);
        applyRef(ref, calculator);
        setCalculator(calculator);
        return () => {
            calculator.destroy();
        };
    }, []);
    useEffect(() => {
        const { attributes, children } = props, settings = __rest(props, ["attributes", "children"]);
        if (calculator)
            calculator.updateSettings(settings);
    });
    return (_jsx(DesmosContext.Provider, Object.assign({ value: calculator }, { children: _jsx("div", Object.assign({ ref: div }, ((_a = props.attributes) !== null && _a !== void 0 ? _a : {}), { children: calculator ? props.children : null })) })));
});
export const Expression = memo(function Expression(props) {
    const calculator = useCalculator();
    const old = useRef({});
    const update = { id: props.id };
    for (const k in props) {
        if (props[k] !== old.current[k]) {
            update[k] = props[k];
        }
    }
    old.current = props;
    calculator.setExpression(update);
    useEffect(() => {
        return () => {
            if (!calculator._destroyed)
                calculator.removeExpression({ id: props.id });
        };
    }, [props.id]);
    return null;
});
function applyRef(ref, val) {
    if (ref === null)
        return;
    if (typeof ref === "function") {
        ref(val);
    }
    else {
        ref.current = val;
    }
}
function makeBasicCalculator(constructor, name) {
    const component = (props, ref) => {
        var _a;
        const [calculator, setCalculator] = useState();
        const div = useRef();
        useEffect(() => {
            const { attributes, children } = props, options = __rest(props, ["attributes", "children"]);
            const calculator = constructor(div.current, options);
            applyRef(ref, calculator);
            setCalculator(calculator);
            return () => {
                calculator.destroy();
            };
        }, []);
        useEffect(() => {
            const { attributes, children } = props, settings = __rest(props, ["attributes", "children"]);
            if (calculator)
                calculator.updateSettings(settings);
        });
        return (_jsx("div", Object.assign({ ref: div }, ((_a = props.attributes) !== null && _a !== void 0 ? _a : {}))));
    };
    Object.defineProperty(component, "name", { value: name });
    return forwardRef(component);
}
export const FourFunctionCalculator = makeBasicCalculator(Desmos.FourFunctionCalculator, "FourFunctionCalculator");
export const ScientificCalculator = makeBasicCalculator(Desmos.ScientificCalculator, "ScientificCalculator");
export function useCalculator() {
    return useContext(DesmosContext);
}
export function useHelperExpression(opts) {
    const calculator = useCalculator();
    const helper = useRef();
    if (helper.current === undefined) {
        helper.current = calculator.HelperExpression(opts);
    }
    const [value, setValue] = useState(helper.current.numericValue);
    useEffect(() => {
        helper.current.observe("numericValue", () => setValue(helper.current.numericValue));
    }, []);
    return value;
}
